module.exports = __webpack_public_path__ + "img/small_whale13.6e52b28e.jpg";